<template>
  <div class="row row-equal">
    <div class="flex xl8 xs12">
      <div class="row">
        <div class="flex xs12 sm4">
          <va-card class="mb-4" color="info">
            <p class="display-2 mb-0" style="color: white; font-size: 28px;">{{ deposit | Currency }}</p>
            <p>{{$t('dashboard.info.deposit-contribution')}}</p>
          </va-card>
        </div>

        <div class="flex xs12 sm4">
          <va-card class="mb-4" color="danger">
            <p class="display-2 mb-0" style="color: white; font-size: 28px;">{{ share | Currency }}</p>
            <p>{{$t('dashboard.info.share-capital')}}</p>
          </va-card>
        </div>

        <div class="flex xs12 sm4">
          <va-card class="mb-4" color="warning">
            <p class="display-2 mb-0" style="color: white; font-size: 28px;">{{ loan | Currency }}</p>
            <p>{{$t('dashboard.info.outstanging-loans')}}</p>
          </va-card>
        </div>

      </div>

      <div class="row">
        <div class="flex xs12 md4">
          <va-card>
            <p class="display-2 mb-1" :style="{color: color_1}">{{ fosa_bal | Currency }}</p>
            <p class="no-wrap">{{$t('dashboard.info.totalFosaBalance')}}</p>
          </va-card>
        </div>
        <div class="flex xs12 md8">
          <va-card>
            <div class="row row-separated">
              <div class="flex xs6 md4" v-for="(fosa, idx) in fosas" :key="idx">
                <p class="display-3 mb-2 text--center" :style="dynamicStyle(idx)">{{ fosa.balance | Currency }}</p>
                <p class="text--center mb-2">{{ fosa.accname }}</p>
              </div>
            </div>
          </va-card>
        </div>
      </div>
    </div>

    <div class="flex xs12 md12 xl4">
      <va-card
        stripe="info"
        :title="$t('dashboard.info.latest-notification')"
      >
        {{ latest_notfication.message }}

        <va-item-label caption>
          {{ latest_notfication.date_sent | formatDate }} {{ latest_notfication.time_sent }}
        </va-item-label>

        <div class="row mt-3">
          <va-button color="primary"  @click="viewall">
            {{$t('dashboard.info.view-all')}}
          </va-button>
        </div>
      </va-card>
    </div>
    <va-modal
      v-model="showModal"
      position="top"
      size = "large"
      :fullscreen = "fullscreen"
      :mobileFullscreen = "fullscreenmobile"
      :title=" $t('notifications')"
      cancelClass="none"      
      :okText=" $t('modal.close') "     
      :cancelText=" $t('modal.cancel')"      
    >
      <template v-for="(notification, i) in notifications">
        <va-item>
          <va-item-section avatar>
            <avatar :username="tostring(i+1)" :color="spinnersColor"></avatar>
          </va-item-section>
          <va-item-section>            
              {{ notification.message }}           

            <va-item-label caption>
              {{ notification.date_sent | formatDate }} {{ notification.time_sent }}
            </va-item-label>      

          </va-item-section>    
        </va-item>
      </template>
    </va-modal>
  </div>
</template>

<script>
import axios from 'axios'
import Avatar from 'vue-avatar'

export default {
  components: {   
    Avatar
  },
  name: 'DashboardInfoBlock',
  data () {
    return {
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      token: JSON.parse(localStorage.getItem('Token')),
      latest_notfication: {},
      showModal:false,
      fullscreen:false,
      fullscreenmobile:true,
      notifications:{},
      spinnersColor: '#537c3d',
      share: '',
      deposit: '',
      loan: '',
      fosa_bal: '',
      fosas: {},
      color_: 'color_',
      color_0: this.$themes.primary,
      color_1: this.$themes.info,
      color_2: this.$themes.success,
      color_3: this.$themes.danger,
      color_4: this.$themes.warning,
    }
  },
  methods: {
    tostring(val){
      return val.toString();
    },
    dynamicStyle (numb) {
      switch (numb) {
        case 0:
          return {
            color: this.color_0,
            fontSize: '20px',
          }
          break
        case 1:
          return {
            color: this.color_1,
            fontSize: '20px',
          }
          break
        case 2:
          return {
            color: this.color_2,
            fontSize: '20px',
          }
          break
        case 3:
          return {
            color: this.color_3,
            fontSize: '20px',
          }
          break
        case 4:
          return {
            color: this.color_4,
            fontSize: '20px',
          }
          break
        default:
          return {
            color: this.color_1,
            fontSize: '20px',
          }
      }
    },
    getDeposit () {
      const self = this
      const posdata = {
        user: this.userData.user_id,
        acc_code: 'DEP',
      }

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}GetAnyAccountBalance`, posdata, config)
        .then(function (res) {
          res = res.data
          self.deposit = res.acc_balance
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    getShare () {
      const self = this
      const posdata = {
        user: this.userData.user_id,
        acc_code: 'SHA',
      }

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}GetAnyAccountBalance`, posdata, config)
        .then(function (res) {
          res = res.data
          self.share = res.acc_balance
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    getLoans () {
      const self = this

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}GetTotalOutStandingLoans`, self.userData.user_id, config)
        .then(function (res) {
          res = res.data
          self.loan = res.amount
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    getFosaBal () {
      const self = this

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}GetAllFosaBalance`, self.userData.user_id, config)
        .then(function (res) {
          res = res.data
          self.fosa_bal = res.amount
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    getFosaAccs () {
      const self = this

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}GetFosaAccounts`, self.userData.user_id, config)
        .then(function (res) {          
          self.fosas = res.data
          localStorage.setItem('UserFosas', JSON.stringify(res.data))
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    viewall(){
      this.showModal = true;
    },
    GetNotifications () {
      const self = this

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }      

      axios.post(`${self.$apiUrl}GetNotifications`, self.userData.user_id, config)
        .then(function (res) {
          res = res.data
          self.notifications = res
          self.latest_notfication = res[0]          
        })
        .catch(function (error) {
          console.log(error)
      })
    },

  },
  created () {
    this.getDeposit()
    this.getShare()
    this.GetNotifications()
    this.getLoans()
    this.getFosaBal()    
    this.getFosaAccs()   
  },
}
</script>

<style lang="scss">
  .row-separated {
    .flex + .flex {
      border-left: 1px solid #e3eaeb;
    }

    @include media-breakpoint-down(xs) {
      p:not(.display-2) {
        font-size: 0.875rem;
      }
    }
  }

  .dashboard {
    .va-card__header--over {
      @include media-breakpoint-up(md) {
        padding-top: 0 !important;
      }
    }
  }
</style>
